<template>
<div class="chapter">
<div class="inner_page">
<div class="acknowPage">
<a id="title1"><h1 class="title"><strong class="b">ACKNOWLEDGMENTS</strong></h1>
<p class="p"><span>This book would not have been possible without the assistance of several individuals and organizations that were gracious in offering access to their collections of Evansville photographs. I also appreciate the support of my husband, Phillip Montgomery. His remarkable memory for names, dates, and events is a priceless resource.</span></p>
<p class="p-indent"><span>Unless otherwise indicated, the images in this volume are from the author’s own collection. Other photographs appear courtesy of the Eager Free Public Library (EFPL), the Rock County Historical Society (RCHS), and the personal collections of photographs of John and Barbara Willoughby (Willoughby), Nancy Kress (Kress), Priscilla Graham Davis (Davis), Barbara Robinson Lawrenz (Lawrenz), David S. Fellows (Fellows), and others that are named in the text. I am especially grateful to Declan Every for allowing me to use the photographic collection of his grandfather Donovan Every (Every).</span></p></a></div><a id="title1">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781439620984_ack01.vue?dd37d1ea